import { render } from "./ReponsiveMainMenu.vue?vue&type=template&id=8e86a33a"
import script from "./ReponsiveMainMenu.vue?vue&type=script&lang=js"
export * from "./ReponsiveMainMenu.vue?vue&type=script&lang=js"
script.render = render

export default script